// extracted by mini-css-extract-plugin
module.exports = {"buttonsContainer":"OnGoingPaymentBox_buttonsContainer__1SjzY","resendInfoText":"OnGoingPaymentBox_resendInfoText__1rOzn"};